import React from 'react';
import PropTypes from 'prop-types';
import { PopupRow } from './ProjectParametersUtils';
import SmilesSection from './SmilesSection/SmilesSection';
import HeaderInfoIcon from '../ProjectRoutes/components/HeaderInfoIcon';
import HeaderInfoTooltip from '../ProjectRoutes/components/HeaderInfoTooltip';

/* eslint-disable react-hooks/exhaustive-deps */
function PredictedParametersIktosIntermediates({ params, onParamsChanged }) {
  return (
    <div className="pp-iktos-intermediates">
      <PopupRow className="rs-column-subheader">
        Enter intermediates
        <HeaderInfoIcon
          tooltipId="info-tooltip-intermediates"
          e2eName="info-tooltip-intermediates"
          contentClassName="extra-wide"
          ariaLabel="Enter intermediates"
          informationIconTitle="Enter intermediates"
        />
        <HeaderInfoTooltip id="info-tooltip-intermediates">
          <div className="rs-tooltip-big__content">
            <div className="info-tooltip-content-list-item">
              Iktos-powered Reaxys predictive retrosynthesis allows users to specify intermediates to be included or excluded. If a route
              contains a structure listed in the &quot;Exclude substructures&quot; section, it will be omitted. Conversely, if structures
              are listed in the &quot;Include substructures&quot; section, only routes containing matching structures will be returned.
              These input structures can be atoms, fragments, functional groups, or complete structures. They can be entered as SMILES
              strings manually or via copy/paste, with up to 10 strings allowed, separated by commas.
            </div>
            <div className="info-tooltip-content-list-item">
              Examples (click the + icon or hit return after adding the SMILES strings):
              <ul className="info-tooltip-content-list init-counter">
                <li className="info-tooltip-content-list-item bullet-dot">
                  type in &quot;Br&quot; in &quot;Exclude substructure&quot; line to exclude all routes with Br-containing structures.
                </li>
                <li className="info-tooltip-content-list-item bullet-dot">
                  type in &quot;N(=O)=O&quot; in &quot;Exclude substructure&quot; line to exclude all routes with NO2-containing compounds.
                </li>
                <li className="info-tooltip-content-list-item bullet-dot">
                  type in &quot;C1=CC=NC=C1&quot; in &quot;Exclude substructure&quot; line to exclude all routes containing pyridine and all
                  pyridine-containing compounds.
                </li>
              </ul>
            </div>
          </div>
        </HeaderInfoTooltip>
      </PopupRow>
      <SmilesSection
        section="include"
        smiles={params.includeSubstructures || []}
        setSmiles={(includeSmiles) => onParamsChanged({ includeSubstructures: includeSmiles })}
      />
      <SmilesSection
        section="exclude"
        smiles={params.excludeSubstructures || []}
        setSmiles={(excludeSmiles) => onParamsChanged({ excludeSubstructures: excludeSmiles })}
      />
    </div>
  );
}

PredictedParametersIktosIntermediates.defaultProps = {
  params: {},
  onParamsChanged: () => null,
};

PredictedParametersIktosIntermediates.propTypes = {
  onParamsChanged: PropTypes.func,
  params: PropTypes.object,
};

export default PredictedParametersIktosIntermediates;
